export const LIST_CUSTOMERS = "customer/getallcustomer";
export const UPDATE_CUSTOMER = "customer/updatecustomer";
export const RE_UPLOAD_NIC = "customer/nicupdate";
export const GET_NIC = (id) => `customer/getnic?customerId=${id}`;

export const CHANGE_PASSWORD         = "customer/resetcustomerpassword";
export const SELF_CHANGE_PASSWORD    = "customer/self-change-password";

export const ACTIVATE_CUSTOMER = "customer/activatecustomer";
export const DEACTIVATE_CUSTOMER = "customer/inactivatecustomer";
